'use strict';

function _getPrototypeOf(o) {
  getPrototypeOf = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

var getPrototypeOf = _getPrototypeOf;

var _getPrototypeOf$1 = getPrototypeOf;

module.exports = _getPrototypeOf$1;
